import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import dayjs from "dayjs";

export default function BasicDatePicker({
  lable,
  onSelect,
}: {
  lable?: Date;
  onSelect: (date: string) => void;
}) {
  const handleDateChange = (date: any) => {
    const dateString = date ? moment(date.$d).format("YYYY-MM-DD") : null;
    if (!dateString) return;
    onSelect(dateString);
  };
  return (
    <div className="w-full">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <DatePicker
            className="w-full"
            value={lable ? dayjs(lable) : null}
            onChange={handleDateChange}
          />
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
}
